import { render, staticRenderFns } from "./OpenRouteEditor.vue?vue&type=template&id=46dd3e65&"
import script from "./OpenRouteEditor.vue?vue&type=script&lang=js&"
export * from "./OpenRouteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports